import { IScrollViewItem } from '../ScrollView/IScrollViewItem';

export abstract class LayoutGroup extends PIXI.Container implements IScrollViewItem {
    public elements: PIXI.Container[] = [];

    constructor(...elements: PIXI.Container[]) {
        super();
        this.addItem(...elements);
    }

    public addItem(...elements: PIXI.Container[]) {
        elements.forEach(element => {
            this.elements.push(element);
            this.addChild(element);
        });
        this.buildLayout();
    }

    public removeItem(...elements: PIXI.Container[]) {
        elements.forEach(x => {
            this.elements.splice(this.elements.indexOf(x), 1);
            x.destroy();
        });
        this.buildLayout();
    }

    public clear() {
        this.removeItem(...this.elements);
    }

    public setDragging(dragging: boolean): void {}

    protected abstract buildLayout(): void;
}
